const SESSION_KEY = 'superoti.warehouse.delman.session'

export type DelmanSession = {
  accessToken: string
  userId: string
  userName: string
  roleCode: 'DELMAN_WAREHOUSE'
  brandId: string
  brandCode: string
  loggedInAt: string
}

export function getDelmanSession(): DelmanSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw) as DelmanSession
  } catch {
    return null
  }
}

export function hasDelmanSession(): boolean {
  return getDelmanSession() !== null
}

export function setDelmanSession(session: DelmanSession): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
}

export function clearDelmanSession(): void {
  localStorage.removeItem(SESSION_KEY)
}
